import {Component, EventEmitter, inject, Input, OnChanges, OnInit, Output, signal} from '@angular/core';
import {MatButton} from '@angular/material/button';
import {MatDialog} from '@angular/material/dialog';
import {
  SelectObjectTemplateModalComponent
} from './select-object-template-modal/select-object-template-modal.component';
import {TemplateGroupInfo} from '../core/definitions/template-group-info';
import {TemplateGroupItem} from '../core/definitions/template-models';
import {UserCacheService} from '../core/user-cache.service';
import {MatIcon} from '@angular/material/icon';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'app-select-object-template-button',
    imports: [
        MatButton,
        MatIcon,
        MatProgressSpinner,
        TranslateModule,
    ],
    templateUrl: './select-object-template-button.component.html',
    styleUrl: './select-object-template-button.component.scss'
})
export class SelectObjectTemplateButtonComponent implements OnInit, OnChanges {
  // Injections
  private readonly userCacheService: UserCacheService = inject(UserCacheService);

  @Input() superobject_type_id: string;
  @Input() templateGroupId: string;

  @Output() changeTemplateGroupId = new EventEmitter<string>();

  readonly dialog = inject(MatDialog);

  loading = signal(false);
  locked = signal(false);
  templateGroups = signal([] as TemplateGroupItem[]);
  private lockedGroupId: string | null = null;

  get selectedTemplateGroup() {
    return this.templateGroups().find((templateGroup) => templateGroup.template_group_id === this.templateGroupId);
  }

  ngOnChanges() {
    this.keepLockedTemplateGroup();
  }

  ngOnInit() {
    this.loading.set(true);
    Promise.all([
      this.userCacheService.getTemplateGroups(),
      this.userCacheService.getUserTemplateGroupInfo(),
    ]).then(([templateGroups, info]) => {
      this.templateGroups.set(templateGroups);
      this.applyLock(info);
    }).finally(() => {
      this.loading.set(false);
    });
  }

  openTemplateSelectModal() {
    if (this.locked()) {
      return;
    }
    this.dialog.open(SelectObjectTemplateModalComponent, {
      data: {
        selectedTemplateGroup: this.selectedTemplateGroup,
        templateGroups: this.templateGroups(),
      }
    }).afterClosed().subscribe((templateGroup: TemplateGroupItem) => {
      if (templateGroup) {
        this.changeTemplateGroupId.emit(templateGroup.template_group_id);
      } else if (templateGroup === null) {
        this.changeTemplateGroupId.emit(null);
      }
    });
  }

  private applyLock(info: TemplateGroupInfo | null | undefined) {
    if (!info?.locked) {
      return;
    }
    this.locked.set(true);
    if (typeof info.template_group_id !== 'string') {
      return;
    }
    this.lockedGroupId = info.template_group_id;
    this.keepLockedTemplateGroup();
  }

  private keepLockedTemplateGroup() {
    if (!this.locked() || !this.lockedGroupId || this.lockedGroupId === this.templateGroupId) {
      return;
    }
    this.changeTemplateGroupId.emit(this.lockedGroupId);
  }
}
